import * as yup from "yup";

const REQUIRED_MESSAGE = "This field is required";

export const idCardSchema = yup.object({
  cardNo: yup.string().required(REQUIRED_MESSAGE),
  iqamaNumber: yup.string().required(REQUIRED_MESSAGE),
  operatorName: yup.string().required(REQUIRED_MESSAGE),
  companyName: yup.string().required(REQUIRED_MESSAGE),
  issueDate: yup.string().required(REQUIRED_MESSAGE),
  expiryDate: yup.string().required(REQUIRED_MESSAGE),
  trade: yup.string().required(REQUIRED_MESSAGE),
  type: yup.number().required(REQUIRED_MESSAGE).typeError(REQUIRED_MESSAGE),
});